import { render, staticRenderFns } from "./assessment-result-percent-item.component.vue?vue&type=template&id=457b6f31&scoped=true&"
import script from "./assessment-result-percent-item.component.vue?vue&type=script&lang=ts&"
export * from "./assessment-result-percent-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-result-percent-item.component.vue?vue&type=style&index=0&id=457b6f31&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b6f31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VTooltip})
